<template>
  <div>
    <div v-if="totalPages > 1 && paginationType === 'pagination'" class="d-flex justify-content-center mt-4">
      <b-pagination
          v-model="currentPage"
          :total-rows="totalPages * paginationSize"
          :per-page="paginationSize"
          :limit="5"
          align="center"
          size="md"
          class="mb-0"
          @change="onChangePage"
      >
        <template #first-text>
          <Icon name="chevronLeftDouble" width="16"/>
        </template>
        <template #prev-text>
          <Icon name="chevronLeft" width="16"/>
        </template>
        <template #next-text>
          <Icon name="chevronRight" width="16"/>
        </template>
        <template #last-text>
          <Icon name="chevronRightDouble" width="16"/>
        </template>
      </b-pagination>
    </div>

    <!-- Infinite Scroll -->
    <div v-if="currentPage < totalPages">
      <div v-if="totalPages > 1 && paginationType === 'infinite'" class="d-flex justify-content-center mt-3 pb-3">
        <b-spinner variant="primary" label="Spinning" v-if="loadingMore"/>
        <b-button @click="$emit('load-more')" variant="primary" size="sm" v-else
                  :disabled="currentPage >= totalPages || loadingMore">
          {{ $t('pages.checkins_detail.load_more') }}
          <Icon name="plus" width="16" vertical-align="sub"/>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  emits: ['change-page', 'load-more'],
  props: {
    loadingMore: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    },
    paginationSize: {
      type: Number,
      default: 20
    },
    paginationType: {
      type: String,
    }
  },
  methods: {
    onChangePage(page) {
      this.$emit('change-page', page)
      const gallery = this.$el.closest('.vertical-gallery, .gallery-media-container')
      const top = gallery ? gallery.getBoundingClientRect().top + window.pageYOffset - 80 : 0
      window.scrollTo({top: Math.max(top, 0), behavior: 'smooth'})
    }
  }
}
</script>